




























import { defineComponent, PropType, ref } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import {
  InputSubscriptionLevelUpdate,
  SubscriptionLevel,
} from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import ModalView from "@/components/ModalView";
import PriceLevelEditForm from "./PriceLevelEditForm.vue";

export default defineComponent({
  name: "EditLevelView",
  components: { PriceLevelEditForm, ModalView, BaseButton },
  props: {
    show: { type: Boolean, required: true },
    loading: { type: Boolean, required: true },
    paymentPackages: { type: Array as PropType<PaymentPackage[]>, required: true },
    priceLevel: { type: Object as PropType<SubscriptionLevel>, required: true },
  },
  setup(props, { emit }) {
    const uploadingInProgress = ref(false);

    const values = ref<FormValues>({
      pricePackageId: props.priceLevel.pricePackageId,
      description: props.priceLevel.description,
      title: props.priceLevel.title,
    });

    const create = () => {
      const data: InputSubscriptionLevelUpdate = {
        id: props.priceLevel.id,
        pricePackageId: values.value.pricePackageId,
        description: values.value.description,
        title: values.value.title,
      };
      emit("update", data);
    };
    return {
      values,
      create,
      uploadingInProgress,
    };
  },
});
